import React, { Fragment, useEffect, useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import Header from '../../components/Header';
import CupomTable from '../../components/admin/CupomTable';
import CupomModal from '../../components/admin/CupomModal';
import { listarCupons, Cupom, TipoCupom, StatusCupom } from '../../services/cupomService';
import Load from '../../components/Load';

const DELETAR_CUPOM_MUTATION = gql`
  mutation DeletarCupom($codigo: String!) {
    deletarCupom(codigo: $codigo)
  }
`;

const CuponsPage: React.FC = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCupom, setSelectedCupom] = useState<Cupom | null>(null);
  const [feedback, setFeedback] = useState<string | null>(null);
  const [cupons, setCupons] = useState<Cupom[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [codigoFilter, setCodigoFilter] = useState('');
  const [tipoFilter, setTipoFilter] = useState<TipoCupom | ''>('');
  const [statusFilter, setStatusFilter] = useState<StatusCupom | ''>('');

  const fetchCupons = async (nextPage: number = page, nextSize: number = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);
      const params: any = {
        page: nextPage,
        size: nextSize,
        codigo: codigoFilter || undefined,
        tipo: tipoFilter || undefined,
        status: statusFilter || undefined,
      };
      const connection = await listarCupons(params);
      setCupons(connection.items ?? []);
      setTotal(connection.totalItems ?? 0);
    } catch {
      setError('Erro ao carregar cupons.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCupons();
  }, [page, rowsPerPage]);

  const [deleteCupom] = useMutation(DELETAR_CUPOM_MUTATION, {
    onCompleted: () => { void fetchCupons(); },
  });

  const handlePageChange = (p: number, size: number) => {
    setPage(p);
    setRowsPerPage(size);
  };

  const handleDelete = async (codigo: string) => {
    if (!window.confirm('Remover cupom?')) return;
    await deleteCupom({ variables: { codigo } });
  };

  const handleFilterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (page !== 0) {
      setPage(0);
    } else {
      fetchCupons(0, rowsPerPage);
    }
  };

  const handleNew = () => {
    setFeedback(null);
    setSelectedCupom(null);
    setModalOpen(true);
  };

  const handleEdit = (cupom: Cupom) => {
    setFeedback(null);
    setSelectedCupom(cupom);
    setModalOpen(true);
  };

  const handleSaved = () => {
    setModalOpen(false);
    setFeedback(selectedCupom ? 'Cupom atualizado com sucesso.' : 'Cupom criado com sucesso.');
    setSelectedCupom(null);
    fetchCupons();
  };

  return (
    <Fragment>
      <div className="main-wrapper">
        <Header />
        <div className="main-content right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left">
              <div className="middle-wrap">
                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                  
                </div>
                <div className="card w-100 border-0 bg-white shadow-xs p-3 mb-3">
                  <div className="card-body p-4 w-100 bg-white border-0 d-flex rounded-3">
                    <button
                      className="d-inline-block mt-2 me-2 btn btn-link text-white p-0"
                      onClick={() => window.history.back()}
                    >
                      <i className="ti-arrow-left font-sm" />
                    </button>
                    <h4 className="font-xs text-primary fw-600 ms-2 mb-0 mt-2 flex-grow-1">
                      ← Código de desconto
                    </h4>
                    <span className="text-primary mt-2">Total: {total}</span>

                  </div>
                  <form onSubmit={handleFilterSubmit} className="mb-3">
                    <div className="row g-2 align-items-end">
                      <div className="col-md-4">
                        <label htmlFor="codigoFilter" className="form-label">Código</label>
                        <input
                          id="codigoFilter"
                          type="text"
                          className="form-control form-control-sm"
                          value={codigoFilter}
                          onChange={(e) => setCodigoFilter(e.target.value)}
                          placeholder="Buscar por código"
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="tipoFilter" className="form-label">Tipo</label>
                        <select
                          id="tipoFilter"
                          className="form-select form-select-lg"
                          value={tipoFilter}
                          onChange={(e) => setTipoFilter((e.target.value || '') as TipoCupom | '')}
                        >
                          <option value="">Todos</option>
                          <option value="PORCENTAGEM">PORCENTAGEM</option>
                          <option value="FIXO">FIXO</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="statusFilter" className="form-label">Status</label>
                        <select
                          id="statusFilter"
                          className="form-select form-select-lg"
                          value={statusFilter}
                          onChange={(e) => setStatusFilter((e.target.value || '') as StatusCupom | '')}
                        >
                          <option value="">Todos</option>
                          <option value="ATIVO">ATIVO</option>
                          <option value="INATIVO">INATIVO</option>
                        </select>
                      </div>
                      <div className="col-md-2 d-grid">
                        <button type="submit" className="btn btn-primary mb-1">Filtrar</button>
                        <button type="button" className="btn btn-primary" onClick={handleNew}>
                          <i className="bi bi-plus me-1" /> Novo código
                        </button>
                      </div>
                    </div>
                  </form>
                  {loading ? (
                    <Load />
                  ) : error ? (
                    <div className="alert alert-danger">Erro ao carregar cupons.</div>
                  ) : cupons.length === 0 ? (
                    <div className="alert alert-info">Nenhum cupom encontrado.</div>
                  ) : (
                    <>
                      {feedback && (
                        <div className="alert alert-success" role="alert">
                          {feedback}
                        </div>
                      )}
                      <CupomTable
                        cupons={cupons}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={total}
                        onPageChange={handlePageChange}
                        onDelete={handleDelete}
                        onEdit={handleEdit}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CupomModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          cupom={selectedCupom || undefined}
          onSaved={handleSaved}
        />
      </div>
    </Fragment>
  );
};

export default CuponsPage;
